import { PROJECT_SERVICE } from "../consts";

export const PROJECT_API = `${PROJECT_SERVICE}projects`;
